import { Check } from "lucide-react";
import { cn } from "@/modern/utils";
import { PROMOTE_STEPS, usePromotePanel } from "../context/PromotePanelContext";

export const StepIndicator = () => {
  const { currentStep, goToStep, canNavigateToStep } = usePromotePanel();

  return (
    <div className="flex items-center justify-between px-1 py-2.5">
      {PROMOTE_STEPS.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        const interactive = canNavigateToStep(index);

        const icon = (
          <div
            className={cn(
              "w-7 h-7 rounded-md flex items-center justify-center text-xs font-bold transition-all duration-200",
              isCompleted && "bg-emerald-500/90 text-white",
              isActive && "bg-primary text-primary-foreground ring-2 ring-primary/30 ring-offset-1 ring-offset-card",
              !isCompleted && !isActive && "bg-muted text-muted-foreground",
            )}
          >
            {isCompleted ? (
              <Check className="w-3.5 h-3.5" />
            ) : (
              <span>{index + 1}</span>
            )}
          </div>
        );

        const label = (
          <span
            className={cn(
              "text-xs font-medium whitespace-nowrap text-center transition-colors duration-200",
              isCompleted && "text-emerald-500",
              isActive && "text-primary",
              !isCompleted && !isActive && "text-muted-foreground/60",
            )}
          >
            {step.label}
          </span>
        );

        const stepBody =
          interactive ? (
            <button
              type="button"
              onClick={() => goToStep(index)}
              className={cn(
                "flex flex-col items-center gap-1 rounded-lg p-0.5 -m-0.5 min-w-0",
                "hover:opacity-90 transition-opacity",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-card",
              )}
            >
              {icon}
              {label}
            </button>
          ) : (
            <div className="flex flex-col items-center gap-1 min-w-0">
              {icon}
              {label}
            </div>
          );

        return (
          <div key={step.label} className="flex items-center flex-1 last:flex-none">
            {stepBody}

            {index < PROMOTE_STEPS.length - 1 && (
              <div className="flex-1 h-px mx-2.5 mb-4 rounded-full bg-border/60 relative overflow-hidden">
                <div
                  className={cn(
                    "absolute inset-y-0 left-0 bg-emerald-500/80 rounded-full transition-all duration-300",
                    isCompleted ? "w-full" : "w-0",
                  )}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
